/* eslint-disable import/no-unresolved */
import React from 'react';
import { Button, ConfirmationModal, useConfirmationModal } from 'LocalGluons';
import type { PlayableModel } from 'Types';
import { useStore } from 'Store';
import MirroringPreventDialog from 'LocalGluons/components/PlayerContainer/components/MirroringPreventDialog';
import useMirroringCheck from 'LocalGluons/components/PlayerContainer/hooks/useMirroringCheck';
import NavigationService from 'NavigationService';
import { Device } from 'DeviceUtils';
import detailStyles from '../../Details.jss';
import { t } from '../../../../../locale';

interface RestartButtonProps {
    item: PlayableModel;
}

const RestartButton = ({ item }: RestartButtonProps): JSX.Element => {
    const { userData, setPlayerData } = useStore();
    const { setModalContent } = useConfirmationModal();
    const { getIsMirroring } = useMirroringCheck();
    const navigation = NavigationService.getAppNavigationInstance();

    const onClose = () => {
        setPlayerData(null);
        setModalContent(null);

    };

    const onRestartPress = async () => {
        const isMirroring = await getIsMirroring();
        if (isMirroring) {
            // lockToPortrait();
            setModalContent(
                <MirroringPreventDialog
                    setModalContent={setModalContent}
                    onClose={((onClose))} />
            );
        } else if (userData === null) {
            setModalContent(
                <ConfirmationModal
                    icon="warning_yellow_black"
                    header={t('NOT_LOGGED_IN_MSG')}
                    message={t('NOT_LOGGED_IN_TXT')}
                    confirmLabel={t('COMMON.LOGIN')}
                    cancelLabel={t('COMMON.CANCEL')}
                    onConfirm={() => {
                        navigation.navigate('Login');
                        onClose();
                    }}
                    onCancel={onClose}
                    onClose={onClose}
                />
            );
        } else {
            setPlayerData({ item, shouldRewindToStart: true });
        }
    };

    return (
        <Button
            style={{
                button: detailStyles.button
            }}
            isSecondary
            iconName="rotate_left"
            title={t('COMMON.RESTART')}
            onPress={() => {
                if (Device.isWeb) {
                    document.querySelector('#videoPlayer')?.play?.();
                }
                onRestartPress();
            }}
        />
    );
};

export default RestartButton;
